<template>
  <div id="TranshipmentEvaluations">
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <h6>Avaliações</h6>

        <v-btn color="success" small @click="isNewEvaluationDialogOpen = true">Nova avaliação</v-btn>
      </v-card-title>
      <v-card-text class="pa-0 ma-0">
        <div v-if="evaluations.length === 0" class="d-flex justify-center pb-12 pt-2">
          Nenhuma avaliação registrada!
        </div>
        <div
          v-else
          v-for="(evaluation, index) in evaluations"
          :key="index"
          :class="`px-4 py-2${index % 2 !== 1 ? ' evaluation-secondary' : ''}`"
        >
          <div class="mb-2 d-flex justify-space-between align-center">
            <span class="body-2 font-weight-medium">{{ formatCreatedAt(evaluation.createdAt) }}</span>
            <span>
              <v-chip
                v-if="evaluation.readingDate === '0001-01-01T00:00:00'"
                class="px-4"
                color="red"
                text-color="white"
                x-small
              >
                Não lida
              </v-chip>
              <v-chip v-else class="px-4" color="green" text-color="white" x-small> Lida </v-chip>
            </span>
          </div>
          <div class="text-truncate">
            {{ evaluation.evaluation }}
          </div>
        </div>
        <div v-if="totalRecords > 0" class="d-flex py-4 justify-center">
          <v-btn color="primary" small @click="evaluationView = true">Ver todas ({{ totalRecords }}) </v-btn>
        </div>
      </v-card-text>
    </v-card>

    <transhipment-evaluation
      :open="isNewEvaluationDialogOpen"
      @closeEvaluation="closeEvaluation"
      @shouldUpdateEvaluations="fetchTranshipmentEvaluations()"
      :transhipmentId="transhipmentId"
    />

    <transhipment-evaluations-view
      :open="evaluationView"
      @closeEvaluations="closeEvaluations"
      :transhipmentId="transhipmentId"
    />
  </div>
</template>

<script>
import TranshipmentEvaluation from './TranshipmentEvaluation.vue';
import TranshipmentEvaluationsView from './TranshipmentEvaluationsView.vue';
import { mapActions } from 'vuex';
import { format } from 'date-fns';
import { pt } from 'date-fns/locale';

export default {
  name: 'TranshipmentEvaluations',
  components: {
    TranshipmentEvaluation,
    TranshipmentEvaluationsView
  },
  props: {
    transhipmentId: {
      default: null,
      type: String
    }
  },

  data: () => ({
    isNewEvaluationDialogOpen: false,
    evaluationView: false,
    evaluations: [],
    totalRecords: null
  }),

  async created() {
    await this.fetchTranshipmentEvaluations();
  },

  methods: {
    ...mapActions('TranshipmentStore', ['getTranshipmentsEvaluationsByTranshipmentId']),

    async fetchTranshipmentEvaluations(params = { transhipmentId: this.transhipmentId }) {
      try {
        this.isLoading = true;
        const { data, totalRecords } = await this.getTranshipmentsEvaluationsByTranshipmentId(params);
        this.evaluations = data;
        this.totalRecords = totalRecords;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    shouldUpdateEvaluations() {
      this.$emit('shouldUpdateEvaluations');
    },

    formatCreatedAt(date) {
      return format(new Date(date), 'PPP', { locale: pt });
    },

    closeEvaluation() {
      this.isNewEvaluationDialogOpen = false;
    },
    closeEvaluations() {
      this.evaluationView = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
